import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import React, { Fragment, useState } from "react";
import { Button } from "react-admin";
import DeclineButton from "./DeclineButton";
import AcceptButton from "./AcceptButton";
import { StyledButton } from "../../../components/ListShowButton";

export interface IConfirmStudentRenewalButton {
  id: number;
  studentId: number;
  academicYearId: number;
}

export const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  dialogSetDate: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
      bottom: 40,
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const ConfirmStudentRenewalButton = ({
  id,
  studentId,
  academicYearId,
}: IConfirmStudentRenewalButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Update Renewal Status
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Update Renewal Status</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Choose Accept for accepting the student for renewal schedule or
            Decline for declining the student for renewal schedule.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            label="Back"
            style={{ backgroundColor: "#9e9e9e" }}
          />
          <DeclineButton
            id={id}
            studentId={studentId}
            academicYearId={academicYearId}
          />
          <AcceptButton
            id={id}
            studentId={studentId}
            academicYearId={academicYearId}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ConfirmStudentRenewalButton;
